export default "__VITE_ASSET__B6f4q9xp__"